module.exports = __webpack_public_path__ + "static/media/userCover.49044f68.jpg";